export const NEAR_MAX_ALLOWANCE = '250000000000000000000000';
